module.exports = (__webpack_require__(5))(11);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference vendor_aa3164967fb7bbe5dda7
// module id = 30
// module chunks = 1